import { ACTIONS, getRouteToTriggers } from '../constants';
import { createOperation } from '../utils/createOperation';

const deleteTrigger = async ({ orgId, divId, triggerId }) =>
  createOperation(getRouteToTriggers(orgId, divId), triggerId, null, ACTIONS.DELETE);

export { deleteTrigger };
